"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SvgSync01 = function (props) { return (React.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 32", stroke: props.color }, props),
    React.createElement("path", { d: "M11.396 26.357a11.32 11.32 0 0 0 10.27-.542c5.421-3.13 7.279-10.06 4.15-15.482l-.334-.577M6.185 21.666c-3.13-5.42-1.273-12.351 4.148-15.48a11.32 11.32 0 0 1 10.271-.542M3.324 21.779l3.643.976.976-3.643m16.114-6.224.976-3.643 3.643.976" }))); };
exports.default = SvgSync01;
//# sourceMappingURL=Sync01.js.map